import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { ConnectionType } from '../store/schema/ConnectionType';
import {
    default as BasicAuthenticationOptions,
    BasicAuthenticationOptionsProps,
} from './BasicAuthenticationOptions';

const styles = require('./IncomingServerInformation.scss');

export interface IncomingServerInformationProps {
    isBasicAuth: boolean;
    connectionType: ConnectionType;
    renderRemoteSend: boolean;
    remoteSend?: boolean;
    incomingServer?: string;
    incomingPort: string;
    leaveCopy?: boolean;
    leaveCopyDisabled?: boolean;
    basicAuthProps?: BasicAuthenticationOptionsProps;
    onUpdateIncomingServer: (value: string) => void;
    onUpdateIncomingPort: (value: string) => void;
    onUpdateLeaveCopy?: (value: boolean) => void;
    onUpdateRemoteSend?: (value: boolean) => void;
}

@observer
export default class IncomingServerInformation extends React.Component<
    IncomingServerInformationProps,
    {}
> {
    private onLeaveCopyChanged = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        this.props.onUpdateLeaveCopy(checked);
    };

    private onRemoteSendChanged = (
        option: IChoiceGroupOption,
        evt?: React.FormEvent<HTMLElement | HTMLInputElement>
    ) => {
        this.props.onUpdateRemoteSend(option.key === 'RemoteSend');
    };

    private renderImapServerContent = () => {
        return (
            this.props.connectionType === ConnectionType.ImapSmtp && (
                <div>
                    <TextField
                        className={styles.textbox}
                        label={strings.options_connected_advanced_imapServerTextField}
                        value={this.props.incomingServer}
                        onChanged={this.props.onUpdateIncomingServer}
                    />
                    <TextField
                        className={styles.textbox}
                        label={strings.options_connected_advanced_incomingPortTextField}
                        value={this.props.incomingPort}
                        onChanged={this.props.onUpdateIncomingPort}
                    />
                </div>
            )
        );
    };

    private renderPopServerContent = () => {
        return (
            this.props.connectionType === ConnectionType.PopSmtp && (
                <div>
                    <TextField
                        className={styles.textbox}
                        label={strings.options_connected_advanced_popServerTextField}
                        value={this.props.incomingServer}
                        onChanged={this.props.onUpdateIncomingServer}
                    />
                    <TextField
                        className={styles.textbox}
                        label={strings.options_connected_advanced_incomingPortTextField}
                        value={this.props.incomingPort}
                        onChanged={this.props.onUpdateIncomingPort}
                    />
                    <Checkbox
                        className={styles.checkbox}
                        label={strings.options_connected_advanced_leaveCopyCheckbox}
                        defaultChecked={this.props.leaveCopy}
                        onChange={this.onLeaveCopyChanged}
                        disabled={this.props.leaveCopyDisabled}
                    />
                </div>
            )
        );
    };

    private renderRemoteSendContent = () => {
        return (
            this.props.renderRemoteSend && (
                <ChoiceGroup
                    options={[
                        {
                            key: 'RemoteSend',
                            text: strings.options_connected_advanced_remoteSendOption,
                            checked: this.props.remoteSend,
                        },
                        {
                            key: 'LocalSend',
                            text: strings.options_connected_advanced_localSendOption,
                            checked: !this.props.remoteSend,
                        },
                    ]}
                    className={styles.options}
                    required={true}
                    onChanged={this.onRemoteSendChanged}
                />
            )
        );
    };

    render() {
        return (
            <div>
                {this.renderImapServerContent()}
                {this.renderPopServerContent()}
                {this.props.isBasicAuth && (
                    <BasicAuthenticationOptions {...this.props.basicAuthProps} />
                )}
                {this.renderRemoteSendContent()}
            </div>
        );
    }
}
